//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { InstagramLocation } from '@apis/universal-posts/config/universalScheduledPostConfigModel';

/** Location returned from Instagram's location API */
export interface IInstagramApiLocation {
  name: string;
  id: string;
  street?: string;
  city?: string;
  country?: string;
  latitude?: number;
  locatedIn?: string;
  longitude?: number;
  region?: string;
  state?: string;
  zip?: string;
}

/**
 * Maps IInstagramLocation from the Instagram location API
 * to our InstagramLocation type used for drafts/posts
 */
export function toInstagramLocation(
  location: IInstagramApiLocation,
): InstagramLocation {
  return {
    facebookLocationId: location.id,
    locationName: location.name,
    streetAddress: location.street,
    city: location.city,
  };
}

/**
 * Maps our InstagramLocation type used for drafts/posts
 * to IInstagramLocation from the Instagram location API
 */
export function toIInstagramLocation(
  location: InstagramLocation,
): IInstagramApiLocation {
  return {
    id: location.facebookLocationId,
    name: location.locationName,
    street: location.streetAddress,
    city: location.city,
  };
}
